import { api } from '@cma/app'
import {
  UpdateMlsPlatformSyncMutation,
  UpdateMlsPlatformSyncMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useUpdateMlsPlatformSync() {
  const queryClient = useQueryClient()
  return useMutation<
    UpdateMlsPlatformSyncMutation,
    Error,
    UpdateMlsPlatformSyncMutationVariables
  >(
    ({ input, syncMlsCredentialsWithPlatform }) => {
      const query = gql`
        mutation UpdateMlsPlatformSync(
          $input: MlsCredentialInput!
          $syncMlsCredentialsWithPlatform: Boolean
        ) {
          updateMlsCredential(
            input: $input
            syncMlsCredentialsWithPlatform: $syncMlsCredentialsWithPlatform
          ) {
            user {
              syncMlsCredentialsWithPlatform
              mlsCredential {
                code
                name
                password
              }
            }
            errors
          }
        }
      `
      const variables = { input, syncMlsCredentialsWithPlatform }

      return api<UpdateMlsPlatformSyncMutation>({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries(['currentUser'])
        await queryClient.invalidateQueries(['translations'])
      }
    }
  )
}
